import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { Song } from './redux/songsSlice'
dayjs.extend(duration)

export function getSongUrl(song: Song) {
  return `${process.env.REACT_APP_API_BASE_URL}/song/download/${song.file}`
  // return `${Config.SOCKET_URL}/media/${song.artist} - ${song.title}.mp3`
}

export function getSongDuration(seconds?: number) {
  if (!seconds) return

  const dur = dayjs.duration(seconds, 'seconds')
  return dur.hours() > 0 ? dur.format('H:mm:ss') : dur.format('mm:ss')
}
